import { FiUploadCloud } from "react-icons/fi";
import ImagePicker from "../../../component/image-picker";
import { Button } from "antd";
import { useState } from "react";
import { onImgErrorFallback } from "../../../utils/mediaFallback";

function FrameImage(props: any) {
  const [show, setShow] = useState<any>(false);
  const imageUrl =
    typeof props?.image === "string" ? props?.image : props?.image?.imageUrl;
  return (
    <>
      <div>
        {imageUrl ? (
          <div className="quiz-BannerImage2">
            <img
              src={imageUrl}
              className="quiz-BannerImage3"
              onError={onImgErrorFallback}
            />
            <div className="quiz-BannerImage4">
              <div className="quiz-txt1">
                {imageUrl?.substring?.(imageUrl?.lastIndexOf("/") + 1) ||
                  "Selected Image"}
              </div>
              <div>
                <Button
                  size="small"
                  danger
                  onClick={(val: any) => props?.onChagne(null)}
                >
                  Remove
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <div className="quiz-BannerImage" onClick={() => setShow(!show)}>
            <FiUploadCloud size={20} color="grey" />
            <div style={{ margin: 5 }} />
            <div>Select Image</div>
          </div>
        )}
        {show ? (
          <ImagePicker
            visible={show}
            close={() => setShow(false)}
            onSubmit={(val: any) => props?.onChagne(val?.image_url)}
          />
        ) : null}
      </div>
    </>
  );
}

export default FrameImage;
